<template>
  <v-switch
    v-model="closedFilter"
    :label="$t('chat.filterClosed')"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-closedFilter',
  computed: {
    ...mapGetters({
      closed: 'chat/DmFilters/closed'
    }),
    closedFilter: {
      get () { return this.closed },
      set (closed) { this.setClosed(closed) }
    }
  },
  methods: {
    ...mapActions({
      setClosed: 'chat/DmFilters/filterClosed'
    })
  }
}
</script>

<style>

</style>
